import React from "react";
import { useHistory } from "react-router-dom";
import { BulletPoint, SlideCarousel } from "./components";
import "react-responsive-carousel/lib/styles/carousel.css"; // requires a loader

import optionsIntegrations from "../../../../../assets/images/integration/optionsIntegrations.png";
import activeOrderCreation from "../../../../../assets/images/active-order-create.png";
import manualImportCard from "../../../../../assets/images/manual-import-card.png";

import bagy from "../../../../../assets/images/bagy/bagy.png";
import bagy1 from "../../../../../assets/images/bagy/bagy1.png";
import bagy2 from "../../../../../assets/images/bagy/bagy2.png";
import bagy3 from "../../../../../assets/images/bagy/bagy3.png";
import bagy4 from "../../../../../assets/images/bagy/bagy4.png";
import bagy5 from "../../../../../assets/images/bagy/bagy5.png";
import bagy6 from "../../../../../assets/images/bagy/bagy6.png";
import bagy7 from "../../../../../assets/images/bagy/bagy7.png";
import bagy8 from "../../../../../assets/images/bagy/bagy8.png";
import bagy9 from "../../../../../assets/images/bagy/bagy9.png";
import bagy10 from "../../../../../assets/images/bagy/bagy10.png";
import bagy11 from "../../../../../assets/images/bagy/bagy11.png";
import bagy12 from "../../../../../assets/images/bagy/bagy12.png";
import bagy13 from "../../../../../assets/images/bagy/bagy13.png";
import bagy14 from "../../../../../assets/images/bagy/bagy14.png";
import bagy15 from "../../../../../assets/images/bagy/bagy15.png";
import bagy16 from "../../../../../assets/images/bagy/bagy16.png";
import bagy17 from "../../../../../assets/images/bagy/bagy17.png";

import styles from "./styles.module.scss";

const TutorialBagy = () => {
  const steps1th = [{ image: optionsIntegrations }, { image: bagy }];

  const steps2th = [
    { image: bagy4 },
    { image: bagy5 },
    { image: bagy6 },
    { image: bagy7 },
    { image: bagy17 },
  ];

  const steps3th = [
    { image: bagy8 },
    { image: bagy10 },
    { image: bagy11 },
    { image: bagy12 },
  ];

  const steps4th = [
    { image: bagy9 },
  ];

  const steps5th = [
    { image: bagy13 },
    { image: bagy14 },
    { image: bagy15 }
  ];

  const steps6th = [
    { image: manualImportCard },
    { image: bagy16 }
  ];

  const history = useHistory();

  return (
    <main className={styles.container}>
      <div className={styles.content}>
        <header className={styles.contentHeader}>
          <p>Como fazer a integração?</p>
        </header>
        <div className={styles.contentBody}>
          <section className={styles.contentSection}>
            <h4>Passo a passo para conectar sua plataforma BAGY à BRCom</h4>
            <br></br>
            <br></br>
            <p><b>ATENÇÃO:</b> A Bagy cobra uma <b>mensalidade</b> para disponibilizar a chave API</p>


            <BulletPoint order="1">
              <p>
                Na tela de <b>Integrações</b>, clique em <b>Selecionar</b> do
                segundo card e depois clique em <b>Configurações</b> no card da
                plataforma BAGY
              </p>
            </BulletPoint>

            <SlideCarousel steps={steps1th} />

            <BulletPoint order="2">
              <p>
                Você será redirecionado para a tela de Configurações onde serão
                necessárias algumas chaves de aplicação do usuário BAGY.
              </p>
            </BulletPoint>

            <div className={styles.imgs}>
              <img
                src={bagy1}
                alt="Imagem tutorial bagy"
                className={styles.cardImage}
              />
            </div>

            <BulletPoint order="3">
              <p>
                Para obter essas chaves de aplicação, acesse seu painel{" "}
                <b>Admin da BAGY</b> e siga os seguintes passos:
              </p>
            </BulletPoint>

            <SlideCarousel steps={steps2th} />

            <BulletPoint order="4">
              <p>
                Após ativar a integração, insira as informações de{" "}
                <b>endereço do remetente</b>. Começe pelo CEP para preencher
                automaticamente as informações do endereço.
              </p>
            </BulletPoint>

            <div className={styles.imgs}>
              <img
                src={bagy2}
                alt="Imagem tutorial bagy"
                className={styles.cardImage}
              />
            </div>

            <BulletPoint order="5">
              <p>
                Configure se deseja adicionar seguro aos envios, importar pedidos com fretes que não sejam Via BRCom e dias adicionais para manipulação.
                <br></br>
                Estando tudo certo clique em <b>Salvar</b>
              </p>
            </BulletPoint>

            <div className={styles.imgs}>
              <img
                src={bagy3}
                alt="Imagem tutorial bagy"
                className={styles.cardImage}
              />
            </div>

            <div className={styles.bulletpoint}>
              <span>6</span>
              <p>
                Nos próximos passos vamos gerar as planilhas de acordo com as
                opções de <b>frete</b> desejadas.
                É só ir no menu <b>Integrações</b> e depois no sub menu <b>Tabelas</b>.
                <br></br>
                Para gerar uma planilha clique no botão <b>Criar nova tabela</b> e preencha os campos e clique em <b>Gerar tabela</b>.
                <br></br>
                OBS: Para que tudo ocorra bem, aguarde o download de uma planilha ficar disponível para gerar a próxima
              </p>
            </div>

            <SlideCarousel steps={steps3th} />

            <div className={styles.bulletpoint}>
              <span>7</span>
              <p>
                Nós avisaremos por email quando estiver pronta para você baixá-las.
              </p>
            </div>

            <SlideCarousel steps={steps4th} />

            <div className={styles.bulletpoint}>
              <span>8</span>
              <p>Com as planilhas em mãos, podemos fazer o upload e criar as formas de envio:</p>
            </div>

            <SlideCarousel steps={steps5th} />

            <div className={styles.bulletpoint}>
              <span>9</span>
              <p>
                Utilize as seguintes nomenclaturas:
                <br></br>
                <br></br>
                Expresso (Via BRCom)
                <br></br>
                <br></br>
                Econômico (Via BRCom)
                <br></br>
                <br></br>
                Super Econômico (Via BRCom)
                <br></br>
                <br></br>
                Super Expresso (Via BRCom)
              </p>
            </div>

            <div className={styles.bulletpoint}>
              <span>10</span>
              <p>
                Pronto! Se tudo deu certo agora você pode aproveitar nossas opções de <b>frete</b>.
              </p>
            </div>

            <div className={styles.bulletpoint}>
              <span>11</span>
              <p>
                Você também tem a opção de importar manualmente seus pedidos.
              </p>
            </div>

            <SlideCarousel steps={steps6th} />

            <div className={styles.bulletpoint}>
              <span>12</span>
              <p>
                Caso queira desativar a criação de pedido nessa integração, vire a chave para "Desativado"
                <br></br>
                As demais funcionalidades relacionadas a essa integração continuarão ativas.
              </p>
            </div>

            <div className={styles.imgs}>
              <img
                src={activeOrderCreation}
                alt="activeOrderCreation"
                className={styles.cardImage}
              />
            </div>

            <button
              onClick={() => history.push("/integracoes")}
              className={`${styles.button} ${styles.btnBack}`}
            >
              Voltar
            </button>
          </section>
        </div>
      </div>
    </main>
  );
};

export { TutorialBagy };
